import { createEntityAdapter, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { LayoutState, Widget } from "../types";
import { layoutReducers } from "./reducers";

export const widgetsAdapter = createEntityAdapter<Widget>();

export const widgetsSlice = createSlice({
  name: "widgets",
  initialState: widgetsAdapter.getInitialState(),
  reducers: {
    setAllWidgets: widgetsAdapter.setAll,
    addWidget: (state, action: PayloadAction<Widget>) => {
      const widget = action.payload;
      const existingWidgets = widgetsAdapter.getSelectors().selectAll(state);
      const typeCount = existingWidgets.filter(
        (item) => item.widgetContentId === widget.widgetContentId,
      ).length;
      if (typeCount < 2) {
        widgetsAdapter.addOne(state, action);
      }
    },
    deleteWidgetById: widgetsAdapter.removeOne,
  },
});

const layoutsInitialState: LayoutState = {
  layouts: null,
  currentLayouts: [],
};

export const layoutsSlice = createSlice({
  initialState: layoutsInitialState,
  name: "layouts",
  reducers: layoutReducers,
});

export const { setAllWidgets, addWidget, deleteWidgetById } = widgetsSlice.actions;
export const { setAllLayouts, setCurrentLayouts } = layoutsSlice.actions;

export const dashboardsPageReducers = {
  [widgetsSlice.reducerPath]: widgetsSlice.reducer,
  [layoutsSlice.reducerPath]: layoutsSlice.reducer,
};
